import React from 'react';
import { Button, useDisclosure } from '@chakra-ui/react';

import { AssetType } from 'entities/assets/model';
import { AssetsDocument } from 'features/asset/add-assets-modal/graphql/queries.gen';
import { GetAssetsDocument } from 'pages/art-catalog/ui/ArtCatalogTable/queries.gen';
import { ButtonType, trackAssetDeleted } from 'shared/analytics';
import { useAppToast } from 'shared/hooks/toast';
import { TrashBinIcon } from 'shared/icons';
import { EntityDeletionAlert } from 'shared/ui/entity-deletion-alert';

import { useDeleteLayerMutation } from './queries.gen';

interface DeleteLayerButtonProps {
	id: string;
	onCompleted: () => void;
}

export const DeleteLayerButton: React.FC<DeleteLayerButtonProps> = ({
	id,
	onCompleted,
}) => {
	const { isOpen, onClose, onOpen } = useDisclosure();
	const toast = useAppToast();
	const [deleteLayer, { loading }] = useDeleteLayerMutation({
		variables: { id },
		onCompleted: (data) => {
			toast({ title: 'Layer deleted successfully', status: 'success' });
			onCompleted();
			trackAssetDeleted({
				type: AssetType.LAYER,
				filename: data.deleteLayer?.name as string,
				link: data.deleteLayer?.link as string,
			});
		},
		onError: () => toast({ title: 'Layer was not deleted', status: 'error' }),
		refetchQueries: [AssetsDocument, GetAssetsDocument],
	});

	return (
		<>
			<Button
				disabled={loading}
				onClick={onOpen}
				leftIcon={<TrashBinIcon w={6} h={6} />}
			>
				Delete Layer
			</Button>
			{isOpen && (
				<EntityDeletionAlert
					isOpen={isOpen}
					onClose={onClose}
					onSubmit={deleteLayer}
					buttonName={ButtonType.DELETE_LAYER}
					title="Layer Deletion"
					description="If you delete this layer, it can't be restored. Are you sure you want to continue?"
				/>
			)}
		</>
	);
};
